import { useState } from "react";
import { X, AlertTriangle } from "lucide-react";

export default function MoveStageModal({ deal, fromStage, toStage, onCancel, onConfirm }) {
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const isBackward = (fromStage?.stage_order ?? 0) > (toStage?.stage_order ?? 0);

  const submit = async () => {
    if (!comment.trim()) return;
    setSubmitting(true);
    await onConfirm(comment.trim());
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="move-stage-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: "var(--cw-border)" }}>
          <h2 className="cw-h2">Move Deal Across Stages</h2>
          <button onClick={onCancel} className="text-[var(--cw-muted)] hover:text-black" data-testid="close-move-btn">
            <X size={20} />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="text-sm">
            <span className="font-semibold">{deal.company_name}</span> — Move from{" "}
            <span className="font-semibold" style={{ color: "var(--cw-primary)" }}>
              {fromStage?.stage_name}
            </span>{" "}
            to{" "}
            <span className="font-semibold" style={{ color: "var(--cw-primary)" }}>
              {toStage?.stage_name}
            </span>
          </div>

          {isBackward && (
            <div
              className="flex items-start gap-2 px-3 py-2 rounded-md text-sm"
              style={{ background: "rgba(224,161,0,0.1)", color: "#7A5900" }}
              data-testid="backward-warning"
            >
              <AlertTriangle size={16} className="mt-0.5" />
              <div>You are moving this deal <strong>BACKWARDS</strong>. Please confirm.</div>
            </div>
          )}

          <div>
            <label className="cw-caption block mb-1">Reason for moving (required)</label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={3}
              className="w-full px-3 py-2 rounded-md border text-sm outline-none"
              style={{ borderColor: "var(--cw-border)" }}
              placeholder="Add a brief reason…"
              data-testid="move-reason-input"
              autoFocus
            />
          </div>
        </div>
        <div className="border-t px-6 py-4 flex justify-end gap-2" style={{ borderColor: "var(--cw-border)" }}>
          <button onClick={onCancel} className="cw-btn-ghost" data-testid="cancel-move-btn">Cancel</button>
          <button
            onClick={submit}
            disabled={!comment.trim() || submitting}
            className="cw-btn-primary"
            data-testid="confirm-move-btn"
          >
            {submitting ? "Moving…" : "Confirm Move"}
          </button>
        </div>
      </div>
    </div>
  );
}
